
import type {
  BaseErrorResponse,
  GetGroupOffsetsRes,
  GetMessageRes,
  GetMessageTotalRes,
  GetMessagesRes,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useKafka() {
  class Kafka<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Kafka
     * @name KafkaControllerGetMessages
     * @summary Returns the list of messages from the queue
     * @request GET:/api3/kafka/message
     * @secure
     * @response `200` `GetMessagesRes`
     * @response `400` `BaseErrorResponse`
     */
    kafkaControllerGetMessages = (
      query: {
        /**
         * @min 0
         * @example 1
         */
        offset: number;
        /**
         * @min 1
         * @max 10000
         * @example 10
         */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetMessagesRes, BaseErrorResponse>({
        path: '/api3/kafka/message',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Kafka
     * @name KafkaControllerGetMessageTotal
     * @summary Returns the number of messages from the queue
     * @request GET:/api3/kafka/message/count
     * @secure
     * @response `200` `GetMessageTotalRes`
     * @response `400` `BaseErrorResponse`
     */
    kafkaControllerGetMessageTotal = (params: RequestParams = {}) =>
      this.request<GetMessageTotalRes, BaseErrorResponse>({
        path: '/api3/kafka/message/count',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Kafka
     * @name KafkaControllerGetMessage
     * @summary Returns one message from the queue at the specified offset
     * @request GET:/api3/kafka/message/{offset}
     * @secure
     * @response `200` `GetMessageRes`
     * @response `400` `BaseErrorResponse`
     */
    kafkaControllerGetMessage = (offset: number, params: RequestParams = {}) =>
      this.request<GetMessageRes, BaseErrorResponse>({
        path: `/api3/kafka/message/${offset}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Kafka
     * @name KafkaControllerGetTopicOffsets
     * @summary Returns information about group offsets
     * @request GET:/api3/kafka/group-offsets
     * @secure
     * @response `200` `GetGroupOffsetsRes`
     * @response `400` `BaseErrorResponse`
     */
    kafkaControllerGetTopicOffsets = (params: RequestParams = {}) =>
      this.request<GetGroupOffsetsRes, BaseErrorResponse>({
        path: '/api3/kafka/group-offsets',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Kafka();
}
